import { createSelector } from 'reselect';

import * as loadingState from '../constants/loadingState';

export const STORE_PROFILE = 'STORE_PROFILE';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';
export const UPDATE_USER_QUOTA = 'UPDATE_USER_QUOTA';
export const GET_TUTOR_STATISTICAL_DATA = 'GET_TUTOR_STATISTICAL_DATA';
export const GET_TUTOR_STATISTICAL_DATA_SUCCESS =
  'GET_TUTOR_STATISTICAL_DATA_SUCCESS';
export const GET_TUTOR_STATISTICAL_DATA_ERROR =
  'GET_TUTOR_STATISTICAL_DATA_ERROR';
export const UPDATE_AVATAR = 'UPDATE_AVATAR';
export const UPDATE_AVATAR_SUCCESS = 'UPDATE_AVATAR_SUCCESS';
export const UPDATE_AVATAR_ERROR = 'UPDATE_AVATAR_ERROR';
export const RESET_USER = 'RESET_USER';
export const FETCH_QUOTAS_SUCCESS = 'FETCH_QUOTAS_SUCCESS';
export const GET_ACCOUNT_STATUS = 'GET_ACCOUNT_STATUS';
export const FETCH_ACCOUNT_STATUS_SUCCESS = 'FETCH_ACCOUNT_STATUS_SUCCESS';
export const FETCH_ACCOUNT_STATUS_ERROR = 'FETCH_ACCOUNT_STATUS_ERROR';

export const SHOW_USER_COMPLETED_PROFILE_DIALOG =
  'SHOW_USER_COMPLETED_PROFILE_DIALOG';
export const HIDE_USER_COMPLETED_PROFILE_DIALOG =
  'HIDE_USER_COMPLETED_PROFILE_DIALOG';
export const SET_TUTOR_PROGRESS_FINISHED = 'SET_TUTOR_PROGRESS_FINISHED';

export const storeProfile = profile => ({
  type: STORE_PROFILE,
  payload: {
    profile,
  },
});

export const updateUserQuota = ({ subscriptionQuota, tokenQuota }) => ({
  type: UPDATE_USER_QUOTA,
  payload: {
    subscriptionQuota,
    tokenQuota,
  },
});

export const fetchUser = () => ({ type: FETCH_USER });

export const fetchUserSuccess = userData => ({
  type: FETCH_USER_SUCCESS,
  payload: {
    userData,
  },
});

export const fetchUserError = errorCode => ({
  type: FETCH_USER_ERROR,
  payload: {
    errorCode,
  },
});

export const resetUser = () => ({ type: RESET_USER });

export const getTutorStatisticalData = () => ({
  type: GET_TUTOR_STATISTICAL_DATA,
});

export const getTutorStatisticalDataSuccess = data => ({
  type: GET_TUTOR_STATISTICAL_DATA_SUCCESS,
  payload: {
    data,
  },
});

export const getTutorStatisticalDataError = errorCode => ({
  type: GET_TUTOR_STATISTICAL_DATA_ERROR,
  payload: {
    errorCode,
  },
});

export const updateAvatar = newAvatar => ({
  type: UPDATE_AVATAR,
  payload: {
    newAvatar,
  },
});

export const updateAvatarSuccess = avatar => ({
  type: UPDATE_AVATAR_SUCCESS,
  payload: {
    avatar,
  },
});

export const updateAvatarError = errorCode => ({
  type: UPDATE_AVATAR_ERROR,
  payload: {
    errorCode,
  },
});

export const fetchQuotasSuccess = isPaidUser => ({
  type: FETCH_QUOTAS_SUCCESS,
  payload: {
    isPaidUser,
  },
});

export const getAccountStatus = () => ({ type: GET_ACCOUNT_STATUS });

export const fetchAccountStatusSuccess = () => ({
  type: FETCH_ACCOUNT_STATUS_SUCCESS,
});

export const fetchAccountStatusError = errorMessage => ({
  type: FETCH_ACCOUNT_STATUS_ERROR,
  payload: {
    errorMessage,
  },
});

export const showUserCompletedProfileDialog = () => ({
  type: SHOW_USER_COMPLETED_PROFILE_DIALOG,
});

export const hideUserCompletedProfileDialog = () => ({
  type: HIDE_USER_COMPLETED_PROFILE_DIALOG,
});

export const setTutorProgressFinished = () => ({
  type: SET_TUTOR_PROGRESS_FINISHED,
});

const INIT_STATE = {
  data: {},
  loadingStatus: loadingState.EMPTY,
  errorCode: '',
  showUserCompletedProfileDialog: false,
  allowDeleteAccount: false,
  isPaidUser: false,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case STORE_PROFILE:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.profile,
        },
      };
    case UPDATE_USER_QUOTA: {
      const { subscriptionQuota, tokenQuota } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          subscriptionQuota,
          tokenQuota,
        },
      };
    }
    case FETCH_USER:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        data: {
          ...state.data,
          ...action.payload.userData,
        },
      };
    case FETCH_USER_ERROR:
      return {
        ...state,
        errorCode: action.payload.errorCode,
        loadingStatus: loadingState.ERROR,
      };
    case UPDATE_AVATAR:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case UPDATE_AVATAR_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        data: {
          ...state.data,
          avatar: action.payload.avatar,
        },
      };
    case UPDATE_AVATAR_ERROR:
      return {
        ...state,
        errorCode: action.payload.errorCode,
        loadingStatus: loadingState.ERROR,
      };
    case RESET_USER:
      return {
        ...INIT_STATE,
      };
    case GET_TUTOR_STATISTICAL_DATA:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case GET_TUTOR_STATISTICAL_DATA_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      };
    case GET_TUTOR_STATISTICAL_DATA_ERROR:
      return {
        ...state,
        errorCode: action.payload.errorCode,
        loadingStatus: loadingState.ERROR,
      };
    case FETCH_QUOTAS_SUCCESS:
      return {
        ...state,
        isPaidUser: action.payload.isPaidUser,
        loadingStatus: loadingState.READY,
      };
    case GET_ACCOUNT_STATUS:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case FETCH_ACCOUNT_STATUS_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        allowDeleteAccount: true,
      };
    case FETCH_ACCOUNT_STATUS_ERROR:
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
        allowDeleteAccount: false,
        loadingStatus: loadingState.ERROR,
      };
    case SHOW_USER_COMPLETED_PROFILE_DIALOG:
      return {
        ...state,
        showUserCompletedProfileDialog: true,
      };
    case HIDE_USER_COMPLETED_PROFILE_DIALOG:
      return {
        ...state,
        showUserCompletedProfileDialog: false,
      };
    default:
      return { ...state };
  }
};

export default reducer;

export const getProfile = state => state.profile.data;
export const getFetchProfileStatus = state => state.profile.loadingStatus;

export const getAllowDeleteAccount = state => state.profile.allowDeleteAccount;
export const getAccountStatusError = state => state.profile.errorMessage;

export const getInvoiceLoveCodeList = createSelector(
  getProfile,
  data => data.invoiceLoveCodeList
);

export const getUserLatestInvoiceInfo = createSelector(
  getProfile,
  data => data.latestInvoiceInfo || {}
);

export const getUserComeFromAppName = createSelector(
  getProfile,
  data => data.applicationName
);

export const getRole = createSelector(getProfile, data => data.role);
export const getAverageRate = createSelector(
  getProfile,
  data => data.averageRate
);
export const getBadges = createSelector(getProfile, data => data.tutorBadges);
export const getCurriculums = createSelector(
  getProfile,
  data => data.curriculums
);
export const getAnswerCount = createSelector(
  getProfile,
  data => data.answerCount
);
export const getSinceDate = createSelector(getProfile, data => data.sinceDate);
export const getAvatar = createSelector(getProfile, data => data.avatar);
export const getFirstName = createSelector(getProfile, data => data.firstName);
export const getUserID = createSelector(getProfile, data => data.userId);
export const getRegion = createSelector(getProfile, data => data.region);

export const getRegionId = createSelector(getProfile, data => data.regionId);

export const getLoginType = createSelector(getProfile, data => data.loginType);

export const getUserEmail = createSelector(getProfile, data => data.email);
export const getUserUnconfirmedEmail = createSelector(
  getProfile,
  data => data.unconfirmedEmail
);

export const getUsername = createSelector(getProfile, data => data.username);

export const getUserPhone = createSelector(
  getProfile,
  data => `${data.countryCode}-${data.phone}`
);

export const getRoleStatus = createSelector(
  getProfile,
  data => data.roleStatus
);

export const getTermsOfService = createSelector(
  getProfile,
  data => data.termsOfService
);

export const getProfileInfo = (state, property) => state.profile.data[property];
export const getIsPaidUser = state =>
  state.profile.paidUser || INIT_STATE.isPaidUser;

export const getShowUserCompletedProfileDialog = state =>
  state.profile.showUserCompletedProfileDialog ||
  INIT_STATE.showUserCompletedProfileDialog;
export const getIsProfileCompleted = createSelector(
  getProfile,
  data => data.isProfileCompleted
);
export const getExtraQuotaByCompletingProfile = createSelector(
  getProfile,
  data => data.extraQuotaByCompletingProfile
);

export const getReferralQuotaThreshold = createSelector(
  getProfile,
  data => data.referralQuotaThreshold
);

export const getProfileCompletionMessage = createSelector(
  getProfile,
  data => data.profileCompletionMessage
);
export const getTutorProgressFinished = createSelector(
  getProfile,
  data => data.tutorProgressFinished
);
export const getTutorCategory = createSelector(
  getProfile,
  data => data.tutorCategory
);
export const getTutorRoleStatus = createSelector(
  getProfile,
  data => data.roleStatus
);



// WEBPACK FOOTER //
// ./app/redux/profile.js